/**
 * edgeAgentAddresses — each site's edge agent address (moved here unchanged from briefingPrompt.js,
 * which re-exports it, so that utils/counts.js can read it without an import cycle: briefingPrompt
 * imports counts).
 *
 * The edge agent's own traffic. The agent polls the site's devices and runs a discovery scan.
 * Its polls arrive flagged (details.event_source modbus_active_poll / self_originated), but on
 * the host-network VM agents its scan arrives as ordinary observed traffic from the agent's own
 * bridge address (event_source live_traffic_capture, self_originated false), because the agent
 * container lacks the `ip` binary and its self-traffic exclusion never fires. Nothing in the
 * event, the edge-node record or the asset list names that address, so it cannot be derived:
 *
 * ANNOTATION — EDGE_AGENT_ADDRESSES is maintained by hand, because it cannot be derived: the agent
 * cannot resolve its own IP (the container has no `ip` binary, so _get_interface_ip returns "" and
 * the agent neither flags its scan nor stamps its address on its polls), and no API row names it.
 *   - foster-rd-substation 10.30.1.1: CONFIRMED on the host — `ip -4 addr` shows it on bridge
 *     aisentry-sgp0 of the atl1 VM, where the agent runs on the host network (2026-11-03 01:15Z).
 *   - aligned-data-center 10.40.1.1: INFERRED, not read on its host — the same pattern in captured
 *     rows (unflagged live_traffic_capture from the subnet's .1, SYN to TCP/502, potential_port_scan).
 * Extend it when a site's agent shows up as an unflagged source of that scan pattern; remove an
 * entry once that agent ships with working self-exclusion. briefingPrompt.test.js checks every
 * entry against captured dev rows and fails on an entry the capture does not support.
 * Any source_ip seen on an event the agent flags as its own is added at run time, so a fixed
 * agent that reports its address needs no entry.
 */
export const EDGE_AGENT_ADDRESSES = {
  'foster-rd-substation': ['10.30.1.1'],
  'aligned-data-center': ['10.40.1.1'],
};
